/** One number with the backend's FileStorageConfig.DEFAULT_MAX_FILE_SIZE_BYTES. */
export const MAX_UPLOAD_SIZE_MB = 5;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;

export function isTooLargeToUpload(file: File): boolean {
  return file.size > MAX_UPLOAD_BYTES;
}

// A Map, not an object literal: a lookup on a plain object walks the prototype, so a body with
// code "toString" would hand t() a function instead of falling back.
const KEY_BY_CODE = new Map<string, string>([
  ['invalid-file', 'general:upload_errors.invalid_file'],
  ['file-too-large', 'general:upload_errors.file_too_large'],
  ['too-many-documents', 'general:upload_errors.too_many_documents'],
]);

function hasCode(data: unknown): data is { code?: unknown } {
  return typeof data === 'object' && data !== null;
}

/**
 * The shared message for an upload the backend refused, or undefined when it sent no code this
 * knows. The caller supplies its own fallback, so each screen keeps its own generic wording.
 *
 * @example t(uploadErrorKey(error.response?.data) ?? 'my_screen.upload_error', { maxSizeMB: MAX_UPLOAD_SIZE_MB })
 */
export function uploadErrorKey(data: unknown): string | undefined {
  const code = hasCode(data) ? data.code : undefined;
  return typeof code === 'string' ? KEY_BY_CODE.get(code) : undefined;
}
